import { Button } from "antd";
import { useTranslation } from "react-i18next";

interface button {
  onClick: any;
  disabled: any;
}

const PreviousButton = ({ onClick, disabled }: button) => {
  const [t] = useTranslation("common");

  return (
    <>
      <Button
        style={{ height: "40px",width:"120px"}}
        size="large"
        className="all-btns prev"
        onClick={onClick}
        disabled={disabled}
      >
        {t("previous")}
      </Button>
    </>
  );
};

export default PreviousButton;
